import { render, staticRenderFns } from "./Control_bak.vue?vue&type=template&id=ddb60a66&scoped=true&"
import script from "./Control_bak.vue?vue&type=script&lang=js&"
export * from "./Control_bak.vue?vue&type=script&lang=js&"
import style0 from "./Control_bak.vue?vue&type=style&index=0&id=ddb60a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb60a66",
  null
  
)

export default component.exports